// extracted by mini-css-extract-plugin
module.exports = {"featuredBadge":"featured-badge_featuredBadge__tcPd0"};